export default __webpack_public_path__ + "static/media/report.1dc9bf10.svg";